import {inject, IReactComponent} from 'mobx-react';
import * as component from './component';

const mapStoresToProps = (stores: any) => ({
    translate: stores.loginStore.localizationService.translate.bind(stores.loginStore.localizationService)
});

const LeftSide = inject(mapStoresToProps)(component.LeftSide) as IReactComponent;

export {LeftSide};
export default LeftSide;
